import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';

import { TimePickerType } from '../../components/CustomTimePicker/CustomTimePicker';
import { useSaveAlertSettings } from '../../actions/alert';
import { saveCustomRouteSettings } from '../../actions/declaration';
import { useHideModal } from '../../actions/modal';
import { savePartitionOrder } from '../../actions/partitions';

export const useSetting = (interval, allowed, gps, partitions, selected) => {
    const hideModal = useHideModal();
    const dispatch = useDispatch();
    const routesDeclaration = useSelector((state) => get(state, 'routesDeclaration', {}));
    const saveAlertSettings = useSaveAlertSettings();

    const [tabIndex, changeTabIndex] = useState(0);

    const [timePickerType, changeTimePickerType] = useState(routesDeclaration.timePickerType || TimePickerType.NATIVE);

    const handleSelect = useCallback((event, value) => changeTabIndex(value), []);

    const handleClose = useCallback(() => hideModal(), []);

    const handleSaveCustomRouteSettings = useCallback(({ interval, allowed, partitions, ...rest }) => {
        dispatch(saveCustomRouteSettings(rest));
        saveAlertSettings({ interval, allowed });
        dispatch(savePartitionOrder(partitions));
    }, []);

    const handleSave = useCallback(() => {
        handleSaveCustomRouteSettings({
            timePickerType,
            allowed,
            interval,
            customRouteSettings: selected,
            allowedDistance: gps.allowedDistance,
            selectionType: gps.selectionType,
            partitions,
        });
        hideModal();
    }, [selected, gps.allowedDistance, gps.selectionType, timePickerType, interval, allowed, partitions]);

    const handleChangeTimePickerType = useCallback((timePickerType) => changeTimePickerType(timePickerType), []);

    return {
        tabIndex,
        timePickerType,
        handleChangeTimePickerType,
        handleClose,
        handleSave,
        handleSelect
    };
};
